import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, Inject } from '@angular/core';
import { CommonService } from '../services/common.service';

@Directive({ selector: '[webpimage]' })
export class ImgLazyDirective {
  constructor(private el: ElementRef,@Inject(DOCUMENT) private document: Document,private common:CommonService) { }

  ngOnInit() {
    if(!this.common.isBrowser) return;
    const canvas = this.document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const image = new Image();
    image.src = this.el.nativeElement.src;
    image.onload = () => {
      const aspectRatio = image.width / image.height;
      const width = this.el.nativeElement.parentElement.offsetWidth;
      const height = width / aspectRatio;
      canvas.width = width;
      canvas.height = height;
      ctx?.drawImage(image, 0, 0, width, height);
      const resizedImage = canvas.toDataURL('image/webp');
      this.el.nativeElement.setAttribute('src', resizedImage);
      this.el.nativeElement.width = width;
      this.el.nativeElement.height = height;
    };
  }
}